module.exports = __webpack_public_path__ + "img/COcgq2.2fec7515.png";